var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4272_23928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4587 16.625V15.0417C13.4587 14.2018 13.125 13.3964 12.5312 12.8025C11.9373 12.2086 11.1318 11.875 10.292 11.875H3.95866C3.11881 11.875 2.31335 12.2086 1.71949 12.8025C1.12562 13.3964 0.791992 14.2018 0.791992 15.0417V16.625",
    stroke: "#07575B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12467 8.70833C8.87358 8.70833 10.2913 7.29057 10.2913 5.54167C10.2913 3.79276 8.87358 2.375 7.12467 2.375C5.37577 2.375 3.95801 3.79276 3.95801 5.54167C3.95801 7.29057 5.37577 8.70833 7.12467 8.70833Z",
    stroke: "#07575B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.208 16.6251V15.0418C18.2075 14.3401 17.974 13.6586 17.5441 13.104C17.1142 12.5495 16.5124 12.1534 15.833 11.978",
    stroke: "#07575B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.667 2.47803C13.3482 2.65243 13.9519 3.04858 14.383 3.60402C14.8142 4.15946 15.0482 4.8426 15.0482 5.54574C15.0482 6.24887 14.8142 6.93201 14.383 7.48745C13.9519 8.04289 13.3482 8.43904 12.667 8.61344",
    stroke: "#07575B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4272_23928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.c1c2dae1a5168d09e1d34553c5eab41c.svg";
export { ForwardRef as ReactComponent };